module.exports = __webpack_public_path__ + "img/img_title4.c6c72b53.png";